export const cardDetails = (card) => {
    if (card.card_faces === null) {
        return (card.printed_type_line ? card.printed_type_line : card.printed_type_line)
        // <Typography variant="h6">{card.printed_type_line ? card.printed_type_line : card.printed_type_line}</Typography><br/>
        // <Typography>{card.printed_text ? card.printed_text : card.oracle_text}</Typography><br/>
        // <Typography>{card.flavor_text}</Typography><br/>
        // <Typography>Illustrated by {card.artist}</Typography><br/>
        // <Typography variant="h6">Legality</Typography><br/>

    } else {
        return (card.card_faces[0].printed_text ? card.card_faces[0].printed_text : card.card_faces[0].oracle_text)
    }
}

export const isInPaper = (games) => {
    return !games || games.includes('paper')
}
